import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@design-system';
import { PolicyOption } from '../hooks/useProjectionForPolicy';

interface PolicyPickerProps {
  options: PolicyOption[];
  value: string | undefined;
  onChange: (policyId: string) => void;
}

export function PolicyPicker({ options, value, onChange }: PolicyPickerProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[360px]">
        <SelectValue placeholder="Select a policy" />
      </SelectTrigger>
      <SelectContent>
        {options.map(option => (
          <SelectItem key={option.fundingSourceId} value={option.fundingSourceId}>
            <span className="flex items-center gap-2">
              <span>{option.label}</span>
              {!option.hasProjection && (
                <span className="text-xs text-gray-400">(no data yet)</span>
              )}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
